<template>
	<div style="width: 100%">
		<h1>Traitement</h1>
		<treatment ref="myTreatment"></treatment>
	</div>
</template>

<script>
	import treatment from "../components/treatment.vue";
	import treatments from "../services/treatments.js";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	import database from "./database.vue"
	import create from "./Create.vue"

	import store from "../store";

	export default {
		name: "view_treatment",
		components: {
			FadeLoader: FadeLoader,
			treatment: treatment,
		},
		data() {
			return {
				id_treatment: 42,
			};
		},
		methods: {},
		mounted: async function () {
			if (store.state.user.rules && !store.state.user.rules.projects) {
				this.$router.push({ name: "profile" });
			}

			var self = this;
			self.id_treatment = this.$route.params.id;
			this.$refs.myTreatment.start(this.$route.params.id);
		},
		beforeDestroy: async function () {
			if (this.inter) {
				clearInterval(this.inter);
			}
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}
</style>
